import { render, staticRenderFns } from "./BusinessStatusYN.vue?vue&type=template&id=fab256c4"
import script from "./BusinessStatusYN.vue?vue&type=script&lang=js"
export * from "./BusinessStatusYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports